import OrphanedAssignmentsProjectGroupedByClientAdmin from '../Contents/Operations/Assignments/OrphanedAssignment/OrphanedAssignmentsProjectGroupedByClientAdmin';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import React from 'react';

export default class OrphanedAssignmentsProjectGroupedByOfficeItem {
  constructor(item) {
    if (item) {
      this.OfficeId = item.officeId;
      this.OfficeName = item.officeName;
      this.AssignmentsCount = item.assignmentsCount;
      return;
    }
    this.OfficeId = '';
    this.OfficeName = '';
    this.AssignmentsCount = '';
  }

  static nameOfTheItemDetailList(item) {
    return `Orphaned - Missing Project (Office ID: ${item.OfficeId})`;
  }

  static NameOfTheIdField() {
    return 'OfficeId';
  }

  static Currency() {}

  static CurrencySecondary() {}

  static FieldsToShowInListTable = [
    {
      tabName: 'Assignments',
      tabLabel: 'Assignments',
      icon: 'fa-brands fa-grav fa-2x',
      data: [
        {
          name: OrphanedAssignmentsProjectGroupedByOfficeItem.getAssignmentContent,
          label: 'Assignments',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Office',
        orderById: 'OfficeName',
        data: 'OfficeName',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 70,
      },
      { label: 'Assignments Count', orderById: 'AssignmentsCount', data: 'AssignmentsCount', minWidth: 40 },
    ];
  }

  static getAssignmentContent(item) {
    return <OrphanedAssignmentsProjectGroupedByClientAdmin officeId={item.OfficeId} />;
  }
}
